import throttle from 'lodash/throttle';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
import FontFaceObserver from 'fontfaceobserver';

export default {

  init() {
    this.eventListeners();
    this.scrollbarWidth();
    this.masonryGrids();
  },

  masonryGrids() {
    var grids = document.querySelectorAll('[data-js=masonry]');

    grids.forEach(grid => {
      var msnry = new Masonry(grid, {
        "percentPosition": true,
        "itemSelector": ".grid-item",
        "columnWidth": ".grid-sizer",
        "horizontalOrder": false
      });

      imagesLoaded(grid).on( 'progress', function() {
        msnry.layout();
        console.log('imagesLoaded progress');
      });

      var font = new FontFaceObserver('Copernicus', {
        style: 'normal',
        weight: '500'
      });

      font.load().then(function () {
        msnry.layout();
        console.log('Copernicus is loaded');
      });
    });
  },

  scrollbarWidth() {
    let scrollbarWidth = window.innerWidth - document.body.clientWidth;
    let root = document.querySelector(':root');

    root.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
  },

  eventListeners() {
    window.addEventListener('resize', throttle(function() {
      Common.scrollbarWidth();
    }), 200);
  },

  isMobile() {
    return window.matchMedia('(max-width: 1023px)').matches;
  }

};
